import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-links">
        <Link to="/about">About Us</Link>
        <Link to="/security">Security & Whitepaper</Link>
        <Link to="/contact">Contact</Link>
        <Link to="/terms">Terms</Link>
        <Link to="/privacy">Privacy Policy</Link>
        <Link to="/ip">Intellectual Property</Link>
        <Link to="/feedback">Feedback</Link>
        <Link to="/faq">FAQ</Link>
      </div>
      <div className="footer-copy">
        &copy; {new Date().getFullYear()} Omega Ops Cybernetics Defence Corp. All rights reserved.
        <br />
        Omega Void&reg; is a registered trademark of Omega Ops Cybernetics Defence Corp.
      </div>
    </footer>
  );
};

export default Footer;
